export const fleetConstants = {
    FLEET_LIST_AND_ROBOT_STATUS_BY_USER_EMAIL_REQUEST: "FLEET_LIST_AND_ROBOT_STATUS_BY_USER_EMAIL_REQUEST",
    FLEET_LIST_AND_ROBOT_STATUS_BY_USER_EMAIL_SUCCESS: "FLEET_LIST_AND_ROBOT_STATUS_BY_USER_EMAIL_SUCCESS",
    FLEET_LIST_AND_ROBOT_STATUS_BY_USER_EMAIL_FAIL: "FLEET_LIST_AND_ROBOT_STATUS_BY_USER_EMAIL_FAIL",

    CLEAR_ERRORS: "CLEAR_ERRORS",
};